import { Box, List, Skeleton } from '@bonanza-social/moonlight';
import { useCallback } from 'react';
import { HistoryListProps } from './HistoryList.types';
import EmptyHistory from './EmptyHistory';

function HistoryList<T>({
  items,
  renderItem,
  keyExtractor,
  onEndReached,
  isFetching,
  pageNumber,
  skeletonItemHeight,
}: HistoryListProps<T>) {
  const _renderFooter = useCallback(
    () =>
      isFetching && pageNumber ? (
        <Box gap="space-400" paddingTop="space-400">
          {[...Array(3)].map((_, i) => (
            <Skeleton
              key={`${pageNumber}-${i}`}
              borderRadius="radius-0"
              height={skeletonItemHeight}
            />
          ))}
        </Box>
      ) : null,
    [isFetching, pageNumber, skeletonItemHeight],
  );

  return items.length ? (
    <List
      data={items}
      renderItem={renderItem}
      keyExtractor={keyExtractor}
      contentContainerStyle={{
        gap: 'space-1000',
        paddingBottom: 'safe-area-inset-bottom',
        paddingHorizontal: 'space-200',
      }}
      onEndReached={onEndReached}
      onEndReachedThreshold={0.1}
      ListFooterComponent={_renderFooter}
    />
  ) : (
    <EmptyHistory />
  );
}

export default HistoryList;
